// extracted by mini-css-extract-plugin
var _1 = "BsOat";
export { _1 as "base" }
